module.exports = __webpack_public_path__ + "static/grid-b-08861a712c6703053d28af20261d8310.jpg";